module.exports = __webpack_public_path__ + "img/midfi-4.14b42746.png";